'use strict';
import MxEnum from '../../../../Utils/MxEnum';

const DataQueryEnums = {
	ColumnAlignmentsEnum: new MxEnum({
		Left: 0,
		Center: 1,
		Right: 2,
	}),
	ColumnSortingEnum: new MxEnum({
		None: 0,
		Ascending: 1,
		Descending: 2,
		Disabled: 4,
	}),
	ColumnTitleTypeEnum: new MxEnum({
		IndividualDisplayString: 0,
		FromExpression: 1,
		NoTitle: 2,
	}),
	ColumnDisplayTypeEnum: new MxEnum({
		Visible: 0,
		InvisibleByDefault: 1,
		None: 2,
		Hidden: 3,
	}),
	DisplayImageEnum: new MxEnum({
		None: 0,
		Image: 1,
		ImageWithText: 2,
	}),
	ColorTypeEnum: new MxEnum({
		None: 0,
		CellText: 1,
		CellBackground: 2,
		RowText: 3,
		RowBackground: 4,
	}),
	ColumnSearchTypeEnum: new MxEnum({
		Yes: 0,
		No: 1,
		AutomaticallyDefined: 2,
	}),
};

export default DataQueryEnums;
